export default {
  'Download Mobile App': 'Download App',
  'Buy Now': 'Buy Now',
  'Contact Us': 'Contact Us',
  'Copyright @ 2020, Famikit.com. All rights reserved.': 'Copyright @ 2020, Famikit.com. All rights reserved.',
  'Welcome to FamiKit': 'Welcome to FamiKit',
  'Sign in': 'Sign in',
  'Home': 'Home',
  'Sreen Time': 'Screen Time',
  'Apps Time': 'App Usage',
  'Website Filter': 'Website Filter',
  'Geofences': 'Geofences',
  'Notifications': 'Notifications',
  'My': 'Account',
  'Screen time': 'Screen time',
  'Most apps used': 'Most used apps',
  'No data display': 'No data found',
  "You have not installed Famikit on your child's phone. After installation, you can reopen Famikit on this device to see the statistics of children's mobile phones.": "You have not installed FamiKit on your kid's phone. After installation, you can reopen FamiKit on this device to see your kid's mobile phone statistics.",
  'What should I do ?': 'What should I do ?',
  "1. Get the child's cell phone": "1. Get your child's cell phone",
  '2. Open Google play, search and install famikit': '2. Open Google Play, search and install FamiKit',
  '3. Clock in famikit and log in（ {email} ）, select role child': '3. Launch FamiKit and log in( {email} ), select child role',
  '4. Follow the instructions in famikit to set permissions': "4. Follow FamiKit's instructions to set permissions",
  'Name': 'Name',
  'Used time': 'Used time',
  'Limit duration': 'Limit duration',
  'Restricted period': 'Restricted period',
  'Limit set': 'Limit set',
  'Set App usage time': 'Set app usage time',
  'Limit wechat usage time': 'Limit WeChat usage time',
  'Note: set the maximum time that the app can be used': 'Note: Set the maximum time the app can be used',
  'Repeat': 'Repeat',
  'Save': 'Save',
  'Cancel': 'Cancel',
  'hour': 'hour',
  'min': 'min',
  'Set app usage period': 'Set app usage period',
  'Start': 'Start',
  'End': 'End',
  'Limit Screen usage time': 'Limit Screen usage time',
  'Limited to {time} hours per day': 'Limited to {time} hours per day',
  'Set screen usage time': 'Set screen usage time',
  'Set exception app': 'Set exception app',
  'Limit screenusage time': 'Limit screen usage time',
  'Exception app can be used without time limit': 'Exception app can be used during the time limit',
  'Email cannot be blank.': 'Email cannot be blank.',
  'Please enter a valid email address': 'Please enter a valid email address',
  "Password": "Password",
  "Repeat Password": "Confirm Password",
  'I agree': 'I agree',
  'User agreement': 'User agreement',
  'and': 'and',
  'Privacy policy': 'Privacy policy',
  'Register': 'Register',
  'Existing account?': 'Existing account?',
  'Password cannot be blank.': 'Password cannot be blank.',
  'Repeat Password cannot be blank.': 'Confirm Password cannot be blank.',
  'The two passwords you entered do not match.': 'The two passwords you entered do not match.',
  'Please read and agree to the terms of service first.': 'Please read and agree to the terms of service first.',
  'Username already exists.': 'Username already exists.',
  'unexpected error.': 'unexpected error.',
  'Email': 'Email',
  'Network delay, please try again.': 'Network delay, please try again.',
  'Incomplete parameters.': 'Incomplete parameters.',
  'Username does not exist.': 'Username does not exist.',
  'Incorrect username or password.': 'Incorrect username or password.',
  'Return': 'Back',
  'Choose your subscription plan and get started': 'Choose your subscription plan and get started',
  "Note: the number of devices refers to the number of children's devices that can be bound. Binding is to access your child's device and install it from Google play.": "Note: The number of devices refers to the number of children's devices that can be bound. You need to have access to your child's device and install FamiKit from Google play.",
  'Register now': 'Register Now',
  'No account?': 'No Account?',
  'Add to Cart': 'Add to Cart',
  'Store': 'Store',
  'MONTHLY': 'MONTHLY',
  '$ 7.99 / Month': '$ 7.99 / Month',
  'Can be bound to': 'Can be bound to',
  'devices': 'devices',
  '$ 5.99 / Month': '$ 5.99 / Month',
  '$ 4.99 / Month': '$ 4.99 / Month',
  'Subscribe': 'Subscribe',
  'QUARTERLY': 'QUARTERLY',
  'ANNUAL': 'ANNUAL',
  'Note': 'Note',
  'download New Version Note!': 'New Version Available!',
  'No': 'No',
  'Yes': 'Yes',
  'Account expired': 'Account expired',
  'Account expired Please renew!': 'Your account has expired, please renew!',
  'New data is uploading, it may take a while.': 'New data is uploading, it may take a while.',
  "1. Get your kid's cell phone.": "1. Get your kid's cell phone.",
  "2. Visit famikit.com in browser, download and install FamiKit App.": "2. Visit famikit.com in browser, download and install FamiKit App.",
  "3. Open FamiKit app, sign in（ {email} ）and select kid's role.": "3. Open FamiKit app, sign in( {email} )and select kid's role.",
  '4. Follow the instructions in FamiKit to set permissions.': '4. Follow the instructions in FamiKit to set permissions.',
  '5. Refresh this page.': '5. Refresh this page.',
  'Refresh Now.': 'Refresh Now.',
  'Limited to {time} per day': 'Limited to {time} per day',
  'Current account is not activated.': 'Current account is not activated.',
  'About': 'About',
  'User privacy agreement': 'User privacy agreement',
  'No data found': 'No data found',
  'Updated {times} ago': 'Updated {times} ago',
  'No location information': 'No location information',
  'please wait...': 'Please wait...',
  'Used for': 'Used for',
  'Today': 'Today',
  'Yesterday': 'Yesterday',
  'Last 3 Days': 'Last 3 Days',
  'Last 7 Days': 'Last 7 Days',
  'Social contact': 'Social Apps',
  'Other': 'Other',
  'Game': 'Game',
  'Please confirm': 'Please confirm',
  '1. The childs mobile phone is connected to the Internet and the position switch is turned on.': "1. Your kid's mobile phone is connected to Internet and the Location switch is turned on.",
  '2. Whether the famikit in the childs mobile phone is turned on.': "2. Whether FamiKit is turned on in your kid's mobile phone.",
  'OK': 'OK',
  'Valid until': 'Valid until',
  'Update subscription': 'Update subscription',
  'kids equipment': "Kid's device",
  'Disconnect': 'Disconnect',
  'My Account': 'My Account',
  'Sign out': 'Sign out',
  'Cancel account': 'Cancel account',
  'You will not be able to receive device status after disconnection. Are you sure you want to disconnect ?': 'You are not able to receive device status after disconnection. Are you sure you want to disconnect ?',
  'Are you sure you want to exit ?': 'Are you sure you want to exit ?',
  'Warning: after the account is cancelled, your data will be cleared and cannot be retrieved. Are you sure you want to delete the account ?': 'Warning: Once the account is cancelled, your data will be cleared and cannot be retrieved. Are you sure you want to delete the account ?',
  'Delete all': 'Delete all',
  'Mark all as read': 'Mark all as read',
  'Limit time interval': 'Limit time interval',
  'Set Time Limits': 'Set Time Limits',
  'Set screen usage period': 'Set screen usage period',
  'Set app time limit': 'Set app time limit',
  'Limit usage period': 'Limit usage period',
  'Monday': 'Monday',
  'Tuesday': 'Tuesday',
  'Wednesday': 'Wednesday',
  'Thursday': 'Thursday',
  'Friday': 'Friday',
  'Saturday': 'Saturday',
  'Sunday': 'Sunday',
  // 9.28 新增
  'Add exception': 'Add exception',
  'Search locations': 'Search locations',
  'Rule': 'Rule',
  'Prevent': 'Prevent',
  'Allow': 'Allow',
  'Website filtering': 'Website filter',
  'Customize site access, block or allow': 'Customize site access, block or allow',
  'Are you sure you want to delete the filter settings ?': 'Are you sure you want to delete the filter settings ?',
  'Filtering web browser access by category and URL': 'Filtering web browser access by category and URL',
  '（Only Chrome browser is supported）': '(Only Chrome browser is supported)',
  //  10.23新增
  '$ {Month} / Month': '$ {Month} / Month',
  'Radius of the geofence in meters ({0}) m max.': 'Radius of the geofence in meters ({0}) m max.',
  'Out': 'Out',
  'In': 'In',
  'search': 'search',
  'Name the Geofence': 'Name the Geofence',
  'NameBeBlank': 'Name cannot be blank',
  'Radius of the geofence in meters （1000m max.）': 'Radius of the geofence in meters (1000m max.)',
  'Are you sure you want to select the deleted geofence': 'Are you sure you want to delete the seleted geofence',
  'Most Used': 'Most Used',
  'Set Limits': 'Set Limits',
  'Limit Screen Time': 'Limit Screen Time',
  'Allow: {time} ': 'Allow: {time} ',
  'Downtime': 'Downtime',
  'Note: This is the maximum time that kid’s phone can be used.': 'Note: This is the maximum time that kid’s phone can be used.',
  'Always Allowed': 'Always Allowed',
  'Choose apps that your kids can use all the time.': 'Choose apps that your kids can use all the time.',
  'Duration Limit': 'Duration Limit',
  'Customize site access: Prevent or Allow.': 'Customize site access: Prevent or Allow.',
  'Enter URL': 'Enter URL',
  'Restriction': 'Restriction',
  'Exception': 'Exception',
  'Adult': 'Adult Content',
  'Alcohol': 'Alcohol & Tobacco',
  'Anonymizers': 'Anonymizers',
  'Gambling': 'Gambling',
  'Games': 'Games',
  'Job': 'Job',
  'Music': 'Music & Video',
  'News': 'News media',
  'Profanity': 'Profanity',
  'Religions': 'Religions',
  'Search': 'Search',
  'Shopping': 'Shopping',
  'Social': 'Social Apps',
  'Unknown': 'Unknown',
  'Violence': 'Violence',
  'Weapons': 'Weapons',
  'Try it now': 'Try it now',
  'Your kid cannot use the device during the time limit.': 'Your kid cannot use the device during the time limit.',
  // 7、26新增
  'famiKit（ {ver} ）is now available for your kid. Please go toGoogle Play Store and install the latest version of Famikit on yourkid’s device': "FamiKit ({ver}) is now available for your kid. Please go to Google Play Store and install the latest version of FamiKit on your kid's device.",
  'famikit（ {ver} ）is now available for your kid. Please go to': 'FamiKit ({ver}) is now available for your kid. Please go to',
  'famikit.com': 'famikit.com',
  'and install the latest version of Famikit for PC on yours device': 'and install the latest version of FamiKit for PC on your device.',
  '3. Open FamiKit app, sign in（ {email} ）': '3. Open FamiKit app, sign in ({email})',
  'Kid device is Android': 'Kid device is Android',
  'Kid device is Windows': 'Kid device is Windows',
  '2. Visit famikit.com in browser, download and install Famikit App.': '2. Open famikit.com in browser, download and install FamiKit app.',
  "1. Get your kid's PC": "1. Go to your kid's PC",
  '2. Download FamiKit android app from Google Play': '2. Download FamiKit Android app from Google Play Store',
  'Browser Histroy': 'Browser Histroy',
  'Enable Brower History': 'Enable Browser History',
  'After opening, it will record the browsing records of chrome, Firefox, edge and other browsers.': 'After enabling the option, it will record browsing history of Chrome, Firefox, Edge and other browsers.',
  // 7.27新增
  'It will record the browsing history of Chrome, Firefox, Edge and other browsers after you enable it.': 'It will record the browsing history of Chrome, Firefox, Edge and other browsers after you enable it.'
}




// WEBPACK FOOTER //
// ./src/language/en.js